import { createApp, defineComponent, h } from 'vue';
import DefaultComponent from "./components/DefaultComponent";
import router from './router';
import store from './store';
import axios from 'axios';
import i18n from "./i18n";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueSimpleAlert from "vue3-simple-alert";
import VueNextSelect from 'vue-next-select';
import 'vue-next-select/dist/index.css';
import ENV from './config/env';
import "../../public/themes/default/fonts/urbanist/urbanist.css";
import "../../public/themes/default/fonts/iconly/iconly.css";
import "../../public/themes/default/fonts/public/public.css";
import "../../public/themes/default/fonts/fontawesome/fontawesome.css";
import { createHead } from '@vueuse/head';
import VueApexCharts from "vue3-apexcharts";
const head = createHead();

/* Start tooltip alert code */
const toastOptions = {
    position: "bottom-center",
    transition: "Vue-Toastification__bounce",
    timeout: 2000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false
};
/* End tooltip alert code */


/* Start axios code*/
const API_URL = ENV.API_URL;
const API_KEY = ENV.API_KEY;

axios.defaults.baseURL = API_URL + '/api';

axios.interceptors.request.use(
    config => {
        config.headers['x-api-key'] = API_KEY;
        if (localStorage.getItem('vuex')) {
            const vuex = JSON.parse(localStorage.getItem('vuex'));
            const token = vuex.auth.authToken;
            config.headers['Authorization'] = token ? `Bearer ${token}` : '';

            if (vuex.globalState) {
                config.headers['x-localization'] = vuex.globalState.lists.language_code;
            }
        }
        return config;
    },
    error => Promise.reject(error),
);

/* End axios code */
const app = createApp(DefaultComponent);
const AppVueSelect = defineComponent({
    name: 'AppVueSelect',
    inheritAttrs: false,
    setup(_, { attrs, slots }) {
        const hasPlaceholder = attrs.placeholder !== undefined;
        const hasSearchPlaceholder = attrs.searchPlaceholder !== undefined || attrs['search-placeholder'] !== undefined;

        return () => h(
            VueNextSelect,
            {
                ...attrs,
                ...(hasPlaceholder ? {} : { placeholder: i18n.global.t('label.select_one') }),
                ...(hasSearchPlaceholder ? {} : { searchPlaceholder: i18n.global.t('label.search_here') }),
            },
            slots,
        );
    },
});

import syncManager from './services/syncManager';

app.component('vue-select', AppVueSelect)
app.component('v-select', AppVueSelect)
app.use(router)
app.use(store)
app.use(VueSimpleAlert)
app.use(VueApexCharts)
app.use(Toast, toastOptions)
app.config.globalProperties.$env = ENV;
app.use(i18n)
app.use(head)
app.mount('#app');

// Inicializar el gestor de eventos de sincronización offline
syncManager.init(store);

